// Skills Icons
import reactIcon from "./images/react.svg"
import jsIcon from "./images/javascript.svg"
import tsIcon from "./images/ts.svg"
import java from "./images/java.svg"
import angularjs from "./images/angularjs.svg"
import python from "./images/python.svg"
import cpp from  "./images/c++.svg"
import nodejs from  "./images/nodejs.svg"
import flask from  "./images/flask.svg"
import flutter from  "./images/flutter.svg"
import swift from  "./images/swift.svg"
import csharp from  "./images/c#.svg"


// Social Icon
import githubIcon from "./images/github.svg"
import instagramIcon from "./images/instagram.svg"
import linkedinIcon from "./images/linkedin.svg"
import gmailIcon from "./images/igmail.svg"

export default {

  //   Header Details ---------------------
  name: "Shreyas More",
  headerTagline: [
    //Line 1 For Header
    "Software Engineer,",
    //Line 2 For Header
    "Full Stack Developer,",
    //Line 3 For Header
    "and  an avid Researcher",
  ],
  //   Header Paragraph
  headerParagraph:
    "I am a self-motivated, creative and technically sound computer/software engineer with a keen interest in learning new technologies to build enterprise applications. Capable of functioning both in a team and on one's own. I am consummate in the fields of Enterprise Software Development, Web Development, and Machine Learning.",

  //Contact Email
  contactEmail: "staticshreyas@gmail.com",

  // End Header Details -----------------------

  // Work Section ------------------------
  projects: [
    {
      title: "", //Project Title - Decaf
      para:
        "", // Add Your Service Type Here
      //Project Image - Add Your Project Image Here
      imageSrc:
        "https://firebasestorage.googleapis.com/v0/b/my-portfolio-a8cf3.appspot.com/o/projects%2FDecaf_Logo.png?alt=media&token=9e2f7684-d187-4a3e-a5fa-d5749db3e486",
      //Project URL - Add Your Project Url Here
      url: "https://github.com/De-CAF",
    },
    {
      title: "", //Project Title - TCP
      para:
        "", // Add Your Service Type Here
      //Project Image - Add Your Project Image Here
      imageSrc:
        "https://firebasestorage.googleapis.com/v0/b/my-portfolio-a8cf3.appspot.com/o/projects%2FtcpLogo.png?alt=media&token=01d671af-d8af-4f7f-9700-e27cc0fd9742",
      //Project URL - Add Your Project Url Here
      url: "https://github.com/staticshreyas/team-collab-platform",
    },
    {
      title: "", //Project Title - CaptureIt
      para:
        "", // Add Your Service Type Here
      //Project Image - Add Your Project Image Here
      imageSrc:
        "https://firebasestorage.googleapis.com/v0/b/my-portfolio-a8cf3.appspot.com/o/projects%2Fcaptureit-logo.png?alt=media&token=1d8ef366-765a-4659-b693-b55cd83419f3",
      //Project URL - Add Your Project Url Here
      url: "https://github.com/staticshreyas/Attendance-Portal",
    },
    {
      title: "", //Project Title - TMI
      para:
        "", // Add Your Service Type Here
      //Project Image - Add Your Project Image Here
      imageSrc:
        "https://firebasestorage.googleapis.com/v0/b/my-portfolio-a8cf3.appspot.com/o/projects%2FtmiLogo.png?alt=media&token=e094748e-2569-4934-a87e-6a9af4dfc0c3",
      //Project URL - Add Your Project Url Here
      url: "https://themovieplace-7db6b.web.app/home",
    },
    {
      title: "", //Project Title - Add Your Project Title Here
      para:
        "", // Add Your Service Type Here
      //Project Image - Add Your Project Image Here
      imageSrc:
        "https://firebasestorage.googleapis.com/v0/b/my-portfolio-a8cf3.appspot.com/o/projects%2FfitnessLogo.jpeg?alt=media&token=6ccd6620-ba81-40d9-bd4c-15cde1237755",
      //Project URL - Add Your Project Url Here
      url: "https://github.com/staticshreyas/MyFitnessPal",
    },
    {
      title: "Player Position Prediction", //Project Title - Add Your Project Title Here
      para:
        "Using data of fifa 18 players consisting their performance attributes, this system can predict suitable position for that football player to be ideal in the team", // Add Your Service Type Here
      //Project Image - Add Your Project Image Here
      imageSrc:
        "https://firebasestorage.googleapis.com/v0/b/my-portfolio-a8cf3.appspot.com/o/projects%2FfifaLogo.png?alt=media&token=e6b93e80-e794-4599-b617-b090bbafe2d3",
      //Project URL - Add Your Project Url Here
      url: "https://github.com/SanyamSavla/DS-MIP-Predict-Player-Position",
    },

  ],

  // End Work Section -----------------------


  // Skills Section ---------------

  //   Import Icons from the top and link it here
  skills: [
    {
      img: csharp,
      para:
        "C#",
    },
    {
      img: java,
      para:
        "Java",
    },
    {
      img: cpp,
      para:
        "C++",
    },
    {
      img: python,
      para:
        "Python",
    },
    {
      img: jsIcon,
      para:
        "Javascript",
    },
    {
      img: tsIcon,
      para:
        "Typescript",
    },
    {
      img: reactIcon,
      para:
        "React",
    },
    {
      img: angularjs,
      para:
        "Angular",
    },
    {
      img: nodejs,
      para:
        "Node",
    },
    {
      img: flask,
      para:
        "Flask",
    },
    {
      img: flutter,
      para:
        "Flutter",
    },
    {
      img: swift,
      para:
        "Swift",
    },
  ],
  // End Skills Section --------------------------

  //   Research Section --------------------------
  promotionHeading: "Research Work",
  promotionPara:
    "As an enthusiastic researcher, I have written two research papers that have been presented at international conferences and published in the prestigious IEEE and Springer digital libraries.",
  // End Research Section -----------------

  //   Contact Section --------------
  contactSubHeading: "Let's create your next experience together",
  social: [
    // Add Or Remove The Link Accordingly
    { img: githubIcon, url: "https://github.com/staticshreyas" },
    {
      img: instagramIcon,
      url: "https://www.instagram.com/shreyasmore91",
    },
    {
      img: linkedinIcon,
      url: "https://www.linkedin.com/in/shreyas-more-9903b8176/",
    },
    {
      img: gmailIcon,
      url: "mailto:staticshreyas@gmail.com",
    },
  ],
  // End Contact Section ---------------
}

// Thanks for using this template, I would love to hear from you contact me at hello@chetanverma.com
